module.exports = __webpack_public_path__ + "img/m5.aea4b6c4.jpg";